import React, { useContext, useEffect } from 'react';
import { KibButtonNew } from '@chewy/kib-controls-react';
import ManagePetSupport from 'components/manage-pet/ManagePetSupport/ManagePetSupport';
import { PetInterface } from 'types/pet';
import AnalyticsContext from '../../context/AnalyticsContext';
import { ACCOUNT_OVERVIEW_PATH } from '../../util/config';
import './memorial-removed.scss';

export default function MemorialRemoved({ petProfile }: { petProfile: PetInterface }) {
  const removedPetTitle = `We removed ${petProfile.name}'s memorial and profile`;
  const supportText = 'If you need support,';
  const supportLink = 'reach out to us any time.';
  const ctaCopy = 'Go to Account';

  const analytics = useContext(AnalyticsContext);

  const handleGoToAccount = () => {
    analytics.trackRainbow({
      name: 'pet profile memorial - clicked',
      category: 'pet-profile-memorial',
      action: 'click',
      label: 'pet_profile_memorial_confirmation_account',
    });
    if (typeof window !== 'undefined') {
      window.location.href = ACCOUNT_OVERVIEW_PATH;
    }
  };

  useEffect(() => {
    analytics.trackRainbow({
      name: 'pet profile memorial - viewed',
      category: 'pet-profile-memorial',
      action: 'impression',
      label: 'pet_profile_memorial_remove_confirmation',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="memorial-removed-container">
      <div className="memorial-removed-content">
        <div className="memorial-removed__text">
          <div className="memorial-removed__title">{removedPetTitle}</div>
          <ManagePetSupport supportText={supportText} supportLink={supportLink} />
        </div>
        <div className="memorial-removed__button-container">
          <KibButtonNew className="memorial-removed__button" onClick={handleGoToAccount}>
            {ctaCopy}
          </KibButtonNew>
        </div>
      </div>
    </div>
  );
}
